/**
 * Export format to support Node.js scripts
 */
module.exports = {
  cpos: [
    {uuid: '4ba20825-ee3d-4b57-a16c-3d1bdc01970b', type: 'cpo', name: "Vattenfall"},
    {uuid: 'a062dc4a-fbb6-4036-8927-792be60ae09a', type: 'cpo', name: "Engie"},
    {uuid: '33967046-5e84-4db4-aa2a-27971b354ceb', type: 'cpo', name: "OPCHARGE"},
    {uuid: '87feb792-a3e7-4182-ac58-ef532527e07d', type: 'cpo', name: "PARKnCHARGE"},
    {uuid: 'd3cad164-c1c1-46db-8838-ff2905167623', type: 'cpo', name: "Allego"},
    {uuid: 'e4a9e585-7249-45e8-be1d-85a0da47a903', type: 'cpo', name: "Unica"},
    {uuid: 'e6a13c70-975c-4416-a143-6bcc269afd34', type: 'cpo', name: "Total"},
  ],
  getCpoById: (cpos, uuid) => {
    const cpo = cpos.find(cpo => cpo.uuid === uuid)

    if (typeof cpo === 'undefined') {
      return ''
    }

    return cpo
  },
  CPO_TYPE: 'cpo',
}
